import { Action, ThunkDispatch } from '@reduxjs/toolkit';

import { EntityType } from '@frontend/common';
import { useReactiveObject, useReactiveObjects, useResolver } from '@frontend/repository';
import { TransactionClient } from '@frontend/transaction/api';
import { Transaction } from '@frontend/transaction/types';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useTransaction:request': CustomEvent<string>;
    }
}

const REQUEST_TRANSACTION_EVENT = 'useTransaction:request';
const STORAGE_KEY = 'TRX_REQ';

export function transactionRequest(transactionId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_TRANSACTION_EVENT, { detail: transactionId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function TransactionResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_TRANSACTION_EVENT, EntityType.TRANSACTION, (ids) => TransactionClient.resolveTransactions(ids), props.dispatch);
    return <></>;
}

interface UseTransactionResolverProps {
    transactionId?: string;
    fetchOnload?: boolean;
}
interface UseTransactionResolverReturn {
    transaction: Transaction | null;
    initialising: boolean;
    isLoading: boolean;
}

/**
 * @description TransactionResolver must be present in the app for this to work.
 */
export function useReactiveTransaction({ transactionId, fetchOnload = false }: UseTransactionResolverProps): UseTransactionResolverReturn {
    const { object: transaction, initialising, isLoading } = useReactiveObject<Transaction>({ id: transactionId, entity_type: EntityType.TRANSACTION, fetchOnload, resolveFunction: transactionRequest });
    return { transaction, initialising, isLoading };
}

interface UseTransactionsResolverProps {
    transactionIds?: string[];
    fetchOnload?: boolean;
}
interface UseTransactionsResolverReturn {
    transactions: Transaction[];
    initialising: boolean;
    isLoading: boolean;
}

/**
 * @description TransactionResolver must be present in the app for this to work.
 */
export function useReactiveTransactions({ transactionIds, fetchOnload = false }: UseTransactionsResolverProps): UseTransactionsResolverReturn {
    const { objects: transactions, initialising, isLoading } = useReactiveObjects<Transaction>({ ids: transactionIds, entity_type: EntityType.TRANSACTION, fetchOnload, resolveFunction: transactionRequest });
    return { transactions, initialising, isLoading };
}